import { createBrowserHistory } from "history";

//API CALL TYPE
//const TYPE_LOCAL = "LOCAL";
const TYPE_REST = "REST";
//console.log(77, process.env.NODE_ENV);

export enum APILIST {
  LOGIN = "login",
  REGISTER = "register",
}

//CONFIG DATA (Please change here only)
const configs = {
  delay: 500,
  dashbordRefreshRate: 1,
  port: 8015,
  appName: "afripay",
  toastDelay: 5000,
  tokenStorage: "TOKEN_PERSIST",
  type: TYPE_REST,

  // imageUrl: "http://127.0.0.1:8000/blogs/",
  // context: "http://127.0.0.1:8000/api",

  imageUrl: "https://api.goafripay.com/blogs/",
  context : "https://api.goafripay.com/api/v2",
  contextOld: "https://api.goafripay.com/api",


  history: createBrowserHistory(),
  requestTimeOut: 30000,
  apiList: APILIST,
  tablePageSize: 10,
};
export default configs;